/* eslint-disable */
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

const Credit1 = () => {
  const tokens =
    useSelector((state) => state.AccountReducer?.subscription?.tokens) || 0;
  const [isHovered, setIsHovered] = useState(false);
  const [dimensions, setDimensions] = useState({ normal: 0, expanded: 0 });
  const normalRef = useRef(null);
  const expandedRef = useRef(null);
  const { t } = useTranslation();
  const account = useSelector((state) => state.AccountReducer);

  // Mesurer les dimensions du contenu
  useEffect(() => {
    const measureDimensions = () => {
      if (normalRef.current && expandedRef.current) {
        const normalWidth = normalRef.current.scrollWidth;
        const expandedWidth = expandedRef.current.scrollWidth;

        setDimensions({
          normal: normalWidth + 16, // +16 pour le padding
          expanded: expandedWidth + 16,
        });
      }
    };

    // Mesurer après le rendu
    measureDimensions();

    // Mesurer à nouveau si la langue change
    const handleLanguageChange = () => {
      setTimeout(measureDimensions, 100);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [tokens, t]);

  return (
    <div className="flex items-center justify-center p-2">
      {/* Éléments cachés pour mesurer les dimensions */}
      <div className="fixed opacity-0 pointer-events-none whitespace-nowrap">
        <div ref={normalRef} className="flex items-center gap-1 px-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            className="text-[#ffffff] dark:!text-[#caa7e7]"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
          </svg>
          <span className="text-[11px] font-bold text-[#9e68ba] dark:!text-[#f0f0f0]">
            {tokens} {t("navbar.credit1")}
          </span>
        </div>
        <div ref={expandedRef} className="flex items-center gap-2 px-2">
          <span className="text-[11px] font-bold text-[#9e68ba]">
            {t("navbar.credit2")}
          </span>
          <div className="w-8 h-8 bg-[#9b59bf] rounded-full"></div>
        </div>
      </div>

      <motion.div
        className="relative flex h-10 items-center justify-center border border-[#5a2b73] dark:!border-[#3c3a3d] px-2 py-1 rounded-full overflow-hidden"
        initial={{ width: dimensions.normal }}
        animate={{
          width: isHovered ? dimensions.expanded : dimensions.normal,
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          minWidth: dimensions.normal,
          width: isHovered ? dimensions.expanded : dimensions.normal,
        }}
      >
        {/* Contenu normal */}
        <motion.div
          className="flex items-center gap-1 flex-nowrap"
          animate={{
            opacity: isHovered ? 0 : 1,
            scale: isHovered ? 0.8 : 1,
          }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9e68ba"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
          </svg>
          <span className="whitespace-nowrap text-[11px] font-bold text-[#9e68ba]">
            {tokens} {t("navbar.credit1")}
          </span>
        </motion.div>

        {/* Contenu étendu */}
        <motion.div
          className="absolute inset-0 flex items-center justify-center gap-2 text-[#9e68ba] font-medium whitespace-nowrap"
          animate={{
            opacity: isHovered ? 1 : 0,
            scale: isHovered ? 1 : 0.8,
          }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <Link
            to={
              (account.productMode ?? "classic") == "classic"
                ? "/plan"
                : "/digital/plan"
            }
            aria-label={t("ui.walletManagement")}
            className="flex items-center gap-2"
          >
            <span className="text-[11px] font-bold text-[#9e68ba]">
              {t("navbar.credit2")}
            </span>
            <motion.div
              className="flex items-center justify-center w-8 h-8 bg-[#9b59bf] rounded-full hover:bg-[#8a4fa8] transition-colors duration-200"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              aria-label={t("ui.walletManagement")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-circle-plus"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M8 12h8" />
                <path d="M12 8v8" />
              </svg>
            </motion.div>
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Credit1;
